import { render, staticRenderFns } from "./FiscalObligationTable.vue?vue&type=template&id=1d56e038&scoped=true&"
import script from "./FiscalObligationTable.vue?vue&type=script&lang=js&"
export * from "./FiscalObligationTable.vue?vue&type=script&lang=js&"
import style0 from "./FiscalObligationTable.vue?vue&type=style&index=0&id=1d56e038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56e038",
  null
  
)

export default component.exports